import { memo } from 'react';

/** 訂單狀態對應的標籤與色彩 */
const STATUS_MAP: Record<string, { label: string; bg: string; text: string }> = {
  pending_payment: { label: '待付款', bg: 'bg-amber-100', text: 'text-amber-800' },
  paid: { label: '已付款', bg: 'bg-blue-100', text: 'text-blue-800' },
  preparing: { label: '備貨中', bg: 'bg-purple-100', text: 'text-purple-800' },
  shipped: { label: '已出貨', bg: 'bg-teal-100', text: 'text-teal-800' },
  arrived: { label: '已送達', bg: 'bg-green-100', text: 'text-green-800' },
  completed: { label: '已完成', bg: 'bg-green-100', text: 'text-green-800' },
  cancelled: { label: '已取消', bg: 'bg-gray-200', text: 'text-gray-600' },
  returned: { label: '已退回', bg: 'bg-red-100', text: 'text-red-800' },
};

/** 付款狀態對應 */
const PAYMENT_STATUS_MAP: Record<string, { label: string; bg: string; text: string }> = {
  pending: { label: '待付款', bg: 'bg-amber-100', text: 'text-amber-800' },
  paid: { label: '已付款', bg: 'bg-green-100', text: 'text-green-800' },
  failed: { label: '付款失敗', bg: 'bg-red-100', text: 'text-red-800' },
  refunded: { label: '已退款', bg: 'bg-gray-200', text: 'text-gray-600' },
};

interface StatusBadgeProps {
  status: string;
  type?: 'order' | 'payment';
}

export const StatusBadge = memo(function StatusBadge({
  status,
  type = 'order',
}: StatusBadgeProps) {
  const map = type === 'payment' ? PAYMENT_STATUS_MAP : STATUS_MAP;
  const config = map[status];

  if (!config) {
    return (
      <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-gray-100 text-gray-600">
        {status}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.bg} ${config.text}`}
    >
      {config.label}
    </span>
  );
});
